import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../ReduxToolkit/Hooks';
import { setCreatedData } from '../../../../ReduxToolkit/Reducers/ProjectSlice';
import { Form, Formik, ErrorMessage, Field } from 'formik';
import { Col, FormGroup, Label, Row } from 'reactstrap'
import { rechargeInitialValue, rechargeValidation } from '../../../../Data/Application/ProjectList/ProjectList';
import { RechargeInitialValue } from '../../../../Types/Application/ProjectList/ProjectList';
import ButtonSection from '../ProjectCreate/ButtonSection';
import Swal from 'sweetalert2';
import api from '../../../../utils/api';

const RechargeAmountForm = () => {
    const navigate = useNavigate();
    const { createdFormData } = useAppSelector((state) => state.project);
    const dispatch = useAppDispatch();
  
    const projectSubmit = async (values: RechargeInitialValue) => {
      if(!values.cardAmount || isNaN(Number(values.cardAmount)) || Number(values.cardAmount) <= 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Please enter a valid recharge amount.',
        });
        return; // Stop submission if validation fails
      }
      const submittedData = {
        cardRechargeMasterId: 0,
        cardAmount: Number(values.cardAmount),
        isLocked: true
      };
      dispatch(setCreatedData([...createdFormData, submittedData]));
      try {
        const response = await api.post('/api/CardRechargeMaster/AddRechargeAmount', submittedData, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
    
        if (response.status === 200 || response.status === 201) {
          dispatch(setCreatedData([...createdFormData, response.data]));
    
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Recharge amount created successfully.',
          }).then(() => {
            navigate(`${process.env.PUBLIC_URL}/recharge/rechargeList`);
          });
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Unexpected Response',
            text: 'Please try again later.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Submission Failed',
          text: 'Something went wrong while creating the recharge amount.',
        });
      }
    };
    return (
      <Formik initialValues={rechargeInitialValue} validationSchema={rechargeValidation} onSubmit={projectSubmit}>
        {() => (
          <Form className="theme-form">
            <Row>
                <Col sm="4">
                <FormGroup>
                    <Label check>Recharge Amount</Label>
                    <Field name="cardAmount" type="text" className="form-control" placeholder="Enter amount here..." />
                    <ErrorMessage name="cardAmount" component="span" className="text-danger" />
                </FormGroup>
                </Col>
                <Col sm="4" className='mt-4'>
                    <ButtonSection cancel_url={`/recharge/rechargeList`} />
                </Col>
            </Row>
            
          </Form>
        )}
      </Formik>
    )
}

export default RechargeAmountForm